import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { BillsComponent } from "../bills.component";
import { LayoutModule } from "../../../../app/theme/layouts/layout.module";
import { SharedModule } from "../../../../app/freightconfirmation/app.sharemodule";
import { RouterModule } from "@angular/router";
import { DocumentsharedModule } from "../../../../app/documentshared/documentshared.module";
// import { Network_SharedModule } from "../../../../app/Network/network/network_shared.module";
import { NgxBarcodeModule } from "ngx-barcode";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateConfigService } from "../../../theme/home/translateConfig.service";
import { ShortcutMenuModule } from "../../../shortcut-menu/shortcut-menu.module";
// For Translator

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LayoutModule,
    SharedModule,
    RouterModule,
    DocumentsharedModule,
    HttpClientModule,
    //added by vithujan 07-02-2023
    ShortcutMenuModule,
    //end
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    // Network_SharedModule,
    NgxBarcodeModule
  ],
  declarations: [BillsComponent],
  exports: [BillsComponent],
  providers: [TranslateConfigService],
})
export class BillsSharedModule { }
